import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  SadieDashboardRange,
  SadieDashboardResponse,
} from "@/types";

const sadieDashboardQueryKey = (range: SadieDashboardRange) =>
  ["sadie-dashboard", range] as const;

export function useGetSadieDashboard(range: SadieDashboardRange) {
  return useQuery({
    queryKey: sadieDashboardQueryKey(range),
    queryFn: async () => {
      const res = await guacHttpClient.get<
        SadieDashboardResponse,
        HttpResponse<SadieDashboardResponse>
      >("relationships/dashboard", { params: { range } });
      return res.data;
    },
    // A range switch keeps the last numbers up while the new ones load.
    placeholderData: keepPreviousData,
  });
}
